import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import moment from 'moment';

export const capitalizeFLetter = string => {
  return string[0].toUpperCase() + string.slice(1);
};

export const isValidEmail = value => {
  return value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(value);
};

export const idGenerator = () => {
  return Math.floor(Math.random() * 100000);
};

export const linkify = inputText => {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z0-9\\-]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

  return replacedText;
};

export const geValidUrl = (url, ubSecureUrl = false) => {
  if (!url.match(/^[a-zA-Z]+:\/\//)) {
    if (ubSecureUrl) {
      return 'http://' + url;
    }
    return 'https://' + url;
  }

  return url;
};

const dayinWeekEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayinWeekDe = ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'];
const dayinWeekSl = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
const dayinWeekIt = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
const dayinWeekHr = ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'];
const dayinWeekSr = ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'];
const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthDe = ['Jan', 'Feb', 'Mar', 'Apr', 'Kan', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
const monthIt = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
const monthSl = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];
const monthHr = ['Sij', 'Velj', 'Ožu', 'Tra', 'Svi', 'Lip', 'Srp', 'Kol', 'Ruj', 'Lis', 'Stu', 'Pro'];
const monthSr = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];

export const getMonth = (month, lang) => {
  var d2 = '';
  if (lang == 'hr') d2 = monthHr[month];
  else if (lang == 'sl') d2 = monthSl[month];
  else if (lang == 'de') d2 = monthDe[month];
  else if (lang == 'sr') d2 = monthSr[month];
  else if (lang == 'it') d2 = monthIt[month];
  else d2 = monthEn[month];
  return d2;
};

export const getMyDateInWeek = (mydate, lang) => {
  var d = new Date(mydate);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  return d1;
};

export const dateRange = (startDate, endDate, steps = 1, perDay = false) => {
  const dateArray = [];
  let currentDate = new moment(startDate);
  //  console.log(steps);
  while (currentDate <= new moment(endDate)) {
    var endDate2 = new moment(currentDate);
    //endDate2.setUTCDate(endDate2.getUTCDate() + (steps - 1));

    if (steps == 30) {
      endDate2.endOf('month');
      //endDate2.setutcFullYear(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 1, 0);
    } else endDate2.add(steps, 'days');
    /*  console.log('current' + currentDate);
    console.log('end2' + endDate2);*/
    if (perDay) {
      dateArray.push(currentDate.format('YYYY-MM-DD'));
    } else
      dateArray.push({
        s: currentDate.format('YYYY-MM-DD'), //new Date(currentDate).toISOString().slice(0, 10),
        e: endDate2.format('YYYY-MM-DD'), //new Date(endDate2).toISOString().slice(0, 10),
      });
    console.log(dateArray);
    // Use UTC date to prevent problems with time zones and DST
    //currentDate.setUTCDate(currentDate.getUTCDate() + steps);
    //currentDate.setUTCDate(endDate2.getUTCDate() + 1);
    currentDate.set(endDate2.toObject());
    currentDate.add(1, 'days');
    endDate2.add(1, 'days');
    /*if (steps == 30) {
      var z1 = endDate2.getUTCFullYear();
      var z2 = endDate2.getUTCMonth() + 2;
      if (z2 > 12) {
        z1++;
        z2 = 1;
      }
      currentDate.setFullYear(z1, z2, 1);
    }*/
  }

  console.log('dateawray');
  console.log(startDate);
  console.log(endDate);
  console.log(dateArray);

  return dateArray;
};

export const getMyDate1 = (mydate, lang) => {
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var d = new Date(mydate);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  if (lang == 'hr') d2 = monthHr[d.getMonth()];
  else if (lang == 'sr') d2 = monthSr[d.getMonth()];
  else d2 = monthEn[d.getMonth()];

  return '<b>' + d1 + ' ' + d.getDate() + '</b><br/>' + d2; // + ' ' + d.getFullYear();
};

export const getMyDate2 = (mydate, lang) => {
  if (mydate == null) return '-';
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var d = new Date(mydate);
  // console.log(d);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sl') d1 = dayinWeekSl[d.getDay()];
  else if (lang == 'de') d1 = dayinWeekDe[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else if (lang == 'it') d1 = dayinWeekIt[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  if (lang == 'hr') d2 = monthHr[d.getMonth()];
  else if (lang == 'sl') d2 = monthSl[d.getMonth()];
  else if (lang == 'de') d2 = monthDe[d.getMonth()];
  else if (lang == 'sr') d2 = monthSr[d.getMonth()];
  else if (lang == 'it') d2 = monthIt[d.getMonth()];
  else d2 = monthEn[d.getMonth()];
  return '' + d1 + ', ' + d.getDate() + ' ' + d2 + ' ' + d.getFullYear();
};

export const getMyDate3 = (mydate, lang) => {
  if (mydate == null) return '';

  var d = new Date(mydate);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  if (lang == 'hr') d2 = monthHr[d.getMonth()];
  else if (lang == 'sr') d2 = monthSr[d.getMonth()];
  else d2 = monthEn[d.getMonth()];

  return (
    '' +
    d1 +
    ', ' +
    d.getDate() +
    ' ' +
    d2 +
    ' ' +
    d.getFullYear() +
    ' ' +
    ('0' + d.getHours()).slice(-2) +
    ':' +
    ('0' + d.getMinutes()).slice(-2)
  );
};

export const getMyDate = prop => {
  //prop = prop + 'T00:00:00';
  if (String(prop).length == 10) prop = prop + 'T00:00:00';
  var md = new Date(prop);

  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
};

export const getMyTime3 = prop => {
  var md = new Date(prop);
  var dd = String(md.getHours()).padStart(2, '0');
  var mm = String(md.getMinutes()).padStart(2, '0');
  return dd + ':' + mm;
};

export const getMyTime = (time1, time2) => {
  var d1 = new Date(time1);
  var d2 = new Date(time2);

  var s1 = String(d1.getHours()).padStart(2, '0') + ':' + String(d1.getMinutes()).padStart(2, '0');
  var s2 = String(d2.getHours()).padStart(2, '0') + ':' + String(d2.getMinutes()).padStart(2, '0');
  return s1 + ' - ' + s2;
};

export const getMyTime2 = (time1, time2) => {
  var d1 = new Date(time1);
  var d2 = new Date(time2);
  var diff = (d1.getTime() - d2.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
};

export const getMyDate4 = (mydate, lang) => {
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var md = new Date(mydate);
  var dd = String(md.getDate());
  var mm = String(md.getMonth() + 1);
  var yyyy = md.getFullYear();
  return dd + '.' + mm + '.' + yyyy + '.';
};

export const getMyDate5 = (mydate, lang) => {
  var md = new Date(mydate);
  var dd = String(md.getDate());
  var mm = String(md.getMonth() + 1);
  var yyyy = md.getFullYear();
  if (lang == 'hr') return dd + '.' + mm + '.';
  else return mm + '-' + dd;
};

export const getMyDate6 = (mydate, lang) => {
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var md = new Date(mydate);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  if (lang == 'hr') return dd + '' + mm + '' + yyyy;
  else return yyyy + '' + mm + '' + dd;
};

export const formatPrice = (price, lang, decimals) => {
  var priceint = parseFloat(price);
  var myDecimls = 2;
  if (decimals != undefined) myDecimls = decimals;
  if (lang == 'hr') {
    return priceint.toLocaleString('hr-HR', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
  } else if (lang == 'sr') {
    return priceint.toLocaleString('sr-RS', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
  } else {
    return priceint.toLocaleString('en-US', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
  }
};

export const getMyTime4 = time1 => {
  var b = time1.split(/\D/);
  var d1 = new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);

  //var d1 = new Date(time1);
  var today = new Date();
  var s1 = '';
  if (getMyDate(time1) != getMyDate(today)) s1 = getMyDate4(d1, 'hr') + ' ';

  s1 = s1 + String(d1.getHours()).padStart(2, '0') + ':' + String(d1.getMinutes()).padStart(2, '0');
  return s1;
};

export const dateDiffInDays = (a, b) => {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  return Math.abs(Math.floor((utc2 - utc1) / _MS_PER_DAY));
};

export const dateDiffInHours = b => {
  const utc1 = Date.now();
  const utc2 = Date.parse(b);
  const _MS_PER_DAY = 1000 * 60 * 60;
  return Math.abs(Math.floor((utc2 - utc1) / _MS_PER_DAY));
};

export const myFormatDate = (mydate, mode) => {
  var md = new Date(mydate);
  var dd = String(md.getDate());
  var mm = String(md.getMonth() + 1);
  var yyyy = md.getFullYear();
  if (mode == 0) return dd + '/' + mm + '/' + yyyy;
  if (mode == 1) return dd + '.' + mm + '.' + yyyy;
  if (mode == 2) return dd + '-' + mm + '-' + yyyy;
  if (mode == 3) return mm + '/' + dd + '/' + yyyy;
  if (mode == 4) return mm + '-' + dd + '-' + yyyy;
  if (mode == 5) return yyyy + '-' + mm + '-' + dd;
};

export const myFormatDate2 = mode => {
  if (mode == 0) return 'DD/MM/yyyy';
  if (mode == 1) return 'DD.MM.yyyy';
  if (mode == 2) return 'DD-MM-yyyy';
  if (mode == 3) return 'MM/DD/yyyy';
  if (mode == 4) return 'MM-DD-yyyy';
  if (mode == 5) return 'yyyy-MM-DD';
};

export const myFormatPrice = (price, mode, removeThousand = 0, zeroEmpty = 0) => {
  var priceint = parseFloat(price);
  var myDecimls = 2;
  if (zeroEmpty == 1 && priceint == 0) return '';
  if (mode == 0) {
    var x = priceint.toLocaleString('hr-HR', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
    if (removeThousand == 1) x = String(x).replace('.', '');
    return x;
  } else {
    var x = priceint.toLocaleString('en-US', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
    if (removeThousand == 1) x = String(x).replace(',', '');
    return x;
  }
};

export const myGetNumber = (price, mode) => {
  if (price == '') return String(0);
  if (mode == 0) {
    price = String(price).replace('.', '');
    price = String(price).replace(',', '.');
  }
  if (mode == 1) {
    price = String(price).replace(',', '');
  }

  var priceint = parseFloat(price);
  var p = priceint.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  p = String(p).replace(',', '');
  return p;
};

export const getSameDayOfYear = (date, yearsToAdd, correct = true) => {
  console.log('xx');
  console.log(date);
  date = typeof date === 'string' ? new Date(date) : date;
  var retDate = new Date(+date);
  retDate.setYear(retDate.getFullYear() + yearsToAdd);

  var diff = date.getDay() - retDate.getDay();
  if (diff < -4) {
    diff = diff + 7; //go forward instead of backward
  }

  if (correct) retDate.setDate(retDate.getDate() + diff);
  //console.log(retDate.toLocaleDateString());
  return new moment(retDate);
};

export const timeDifference = (date1, minutes = false) => {
  // Convert inputs to Date objects if they aren't already
  if (date1 == null) return;
  const d1 = new Date(date1);
  const d2 = new Date();

  // Calculate the difference in milliseconds
  const diffMs = Math.abs(d2 - d1);

  // Convert to seconds
  const diffSeconds = Math.floor(diffMs / 1000);

  if (minutes) {
    if (diffSeconds < 60 * 15) return true;
    else return false;
  }

  if (diffSeconds < 60) {
    return `${diffSeconds} second${diffSeconds !== 1 ? 's' : ''}`;
  }

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''}`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? 's' : ''}`;
  }

  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
};

// Example usage:
